import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "7b6ea2b3-b22f-4b53-b2d7-8a08c97f55df",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-2-answer-a.svg` },
  },
  {
    id: "7cc0aa20-d28d-4134-a878-ca8b3398c9a4",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-2-answer-b.svg` },
  },
  {
    id: "71c99f65-8513-4251-9fd1-ce6b69ffd5f1",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-2-answer-c.svg` },
  },
  {
    id: "be088568-b483-4797-9d18-b048e48440b8",
    content: "Answer",
    options: { image: `${config.ASSETS_URL}/04/23/task/task-2-answer-d.svg` },
  },
];

export const task: Task = {
  id: "f0144808-296a-41aa-abda-7e5e8823bda1",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["7b6ea2b3-b22f-4b53-b2d7-8a08c97f55df"],
};
